import { call, put, takeLatest, delay } from 'redux-saga/effects';
import { SEG_VIEW } from 'src/store/ActionTypes';

import * as api from 'src/store/api';

function* fetchEntity(action) {
  try {
    const {
      payload: { id, entity },
    } = action;
    if (entity === 'segment') {
      const segment = yield call(api.fetchSegment, id);
      yield put({
        type: SEG_VIEW.FETCH_ENTITY_SUCCEEDED,
        payload: segment,
      });
    } else if (entity === 'cluster') {
      const cluster = yield call(api.fetchCluster, id);
      yield put({
        type: SEG_VIEW.FETCH_ENTITY_SUCCEEDED,
        payload: cluster,
      });
    } else {
      yield put({
        type: SEG_VIEW.FETCH_ENTITY_FAILED,
      });
    }
  } catch (e) {
    yield put({
      type: SEG_VIEW.FETCH_ENTITY_FAILED,
    });
  } finally {
    yield delay(500);
    yield put({
      type: SEG_VIEW.UNSET,
      payload: 'fetchEntityStatus',
    });
  }
}

function* editEntity(action) {
  try {
    const {
      payload: { entity, id, payload },
    } = action;
    if (entity === 'segment') {
      yield call(api.updateSegment, id, payload);
      yield put({
        type: SEG_VIEW.EDIT_ENTITY_SUCCEEDED,
        payload: {
          id,
          payload,
        },
      });
    } else if (entity === 'cluster') {
      yield call(api.updateCluster, id, payload);
      yield put({
        type: SEG_VIEW.EDIT_ENTITY_SUCCEEDED,
        payload: {
          id,
          payload,
        },
      });
    } else {
      yield put({
        type: SEG_VIEW.EDIT_ENTITY_FAILED,
      });
    }
  } catch (e) {
    yield put({
      type: SEG_VIEW.EDIT_ENTITY_FAILED,
    });
  } finally {
    yield delay(500);
    yield put({
      type: SEG_VIEW.UNSET,
      payload: 'editEntityStatus',
    });
  }
}

function* fetchEntitySaga() {
  yield takeLatest(SEG_VIEW.FETCH_ENTITY, fetchEntity);
}

function* editEntitySaga() {
  yield takeLatest(SEG_VIEW.EDIT_ENTITY, editEntity);
}

export default [fetchEntitySaga(), editEntitySaga()];
